import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { 
  ExperimentOutlined, 
  ToolOutlined, 
  ProjectOutlined, 
  ScissorOutlined,
  BuildOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

export default function MolecularCloningPage() {
  const navigate = useNavigate();

  const cloningModules = [
    {
      key: 'sanger',
      title: 'Sanger测序分析',
      description: 'Sanger测序数据质量分析、峰图查看、序列比对等功能',
      icon: <ExperimentOutlined style={{ fontSize: '48px', color: '#1890ff' }} />,
      features: [
        '测序质量分析',
        '峰图可视化',
        '序列比对',
        '突变检测'
      ],
      path: '/cloning/sanger',
      available: true
    },
    {
      key: 'primer',
      title: '引物设计',
      description: 'PCR扩增引物设计、qPCR引物设计、引物特异性检测等功能',
      icon: <ToolOutlined style={{ fontSize: '48px', color: '#52c41a' }} />,
      features: [
        'PCR引物设计',
        'qPCR引物设计',
        '引物特异性检测',
        'Tm值计算'
      ],
      path: '/cloning/primer',
      available: true
    },
    {
      key: 'plasmid',
      title: '质粒构建绘图',
      description: '质粒图谱绘制、基因插入位置标注、载体特征显示等功能',
      icon: <ProjectOutlined style={{ fontSize: '48px', color: '#fa8c16' }} />,
      features: [
        '质粒图谱绘制',
        '基因插入标注',
        '载体特征显示',
        '序列导出'
      ],
      path: '/cloning/plasmid',
      available: false
    },
    {
      key: 'enzyme',
      title: '酶切位点分析',
      description: '限制性内切酶位点预测、酶切图谱分析、多重酶切设计等功能',
      icon: <ScissorOutlined style={{ fontSize: '48px', color: '#f5222d' }} />,
      features: [
        '酶切位点预测',
        '酶切图谱分析',
        '多重酶切设计',
        '酶切片段计算'
      ],
      path: '/cloning/enzyme',
      available: true
    },
    {
      key: 'gene-synthesis',
      title: '基因合成引物设计',
      description: 'PCR基因合成引物设计、寡核优化、重叠区域分析等功能',
      icon: <BuildOutlined style={{ fontSize: '48px', color: '#722ed1' }} />,
      features: [
        'PCR引物设计',
        '寡核长度优化',
        '重叠Tm计算',
        '批量序列处理'
      ],
      path: '/cloning/gene-synthesis',
      available: true
    }
  ];

  return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <Title level={2}>分子克隆</Title>
          <Paragraph style={{ fontSize: '16px', color: '#666' }}>
            提供Sanger测序分析、引物设计、质粒构建绘图、酶切位点分析、基因合成引物设计等分子克隆相关功能
          </Paragraph>
        </div>

        <Row gutter={[24, 24]}>
          {cloningModules.map((module) => (
            <Col xs={24} md={12} lg={6} key={module.key}>
            <Card
              hoverable={module.available}
              style={{ 
                height: '100%',
                cursor: module.available ? 'pointer' : 'not-allowed',
                transition: 'all 0.3s ease',
                opacity: module.available ? 1 : 0.6
              }}
              bodyStyle={{ padding: '32px 24px' }}
              onClick={() => module.available && navigate(module.path)}
            >
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                  {module.icon}
                </div>
                
                <Title level={4} style={{ textAlign: 'center', marginBottom: 16 }}>
                  {module.title}
                  {!module.available && (
                    <span style={{ 
                      fontSize: '12px', 
                      color: '#999', 
                      marginLeft: '8px',
                      fontWeight: 'normal'
                    }}>
                      (即将上线)
                    </span>
                  )}
                </Title>
                
                <Paragraph style={{ 
                  textAlign: 'center', 
                  color: '#666',
                  marginBottom: 24,
                  minHeight: '48px'
                }}>
                  {module.description}
                </Paragraph>
                
                <div>
                  <Title level={5} style={{ marginBottom: 12 }}>主要功能：</Title>
                  <ul style={{ paddingLeft: 20, margin: 0 }}>
                    {module.features.map((feature, index) => (
                      <li key={index} style={{ marginBottom: 4, color: '#666' }}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
  );
}
